import { RequestCodeItemDelete, ReceiveCodeItemDelete, FailCodeItemDelete } from '../action-types';
import { CodetableListState, CodeListItem, CodeListBranch } from '../types-store';

export const mapToRequestDeletingStatus = (state: CodetableListState, action: RequestCodeItemDelete) => mapToStatus(state, action, true);

export const mapToDeletedState = (state: CodetableListState, action: ReceiveCodeItemDelete): Partial<CodetableListState> => {

  const sourceBranch = state.codeListBranch.find(branch => branch.items.find(item => item.id === action.codeId));
  const itemToDelete = sourceBranch && sourceBranch.items.find(item => item.id === action.codeId);

  const itemDescendantsIds = collectItemDescendants(state.codeListBranch, itemToDelete);

  return {
    codeListBranch: removeItemFromBranch(removeDescendants(state.codeListBranch, itemDescendantsIds), sourceBranch, itemToDelete),
    codeListBranchState: removeDescendants(state.codeListBranchState, itemDescendantsIds)
  };
};

const removeDescendants = <T extends { id: number }>(listBranch: T[], itemDescendantsIds: number[]): T[] =>
  listBranch.filter(branch => !itemDescendantsIds.includes(branch.id));

const removeItemFromBranch = (codeListBranch: CodeListBranch[], branch: CodeListBranch, itemToDelete: CodeListItem): CodeListBranch[] =>
  !branch || !itemToDelete
    ? codeListBranch
    : ([...codeListBranch.filter(listBranch => listBranch.id !== branch.id),
    {
      ...branch,
      items: branch.items.filter(item => item.id !== itemToDelete.id),
      numberOfResults: branch.numberOfResults - 1
    }
    ]);

export const collectItemDescendants = (
  codeListBranch: CodeListBranch[],
  itemToDelete: CodeListItem): number[] => {
  if (!itemToDelete) {
    return [];
  }
  const itemBranch = codeListBranch.find(branch => branch.id === itemToDelete.id);
  if (itemBranch) {
    return itemBranch.items.reduce((ids, item) => [...ids, itemBranch.id, ...collectItemDescendants(codeListBranch, item)], []);
  }
  return [itemToDelete.id];
};

export const mapToFailedDeletingStatus = (state: CodetableListState, action: FailCodeItemDelete) => mapToStatus(state, action, false);

const mapToStatus = (
  state: CodetableListState,
  action: RequestCodeItemDelete | FailCodeItemDelete,
  deletingCodeItem: boolean) => state.codeListBranch.map(branch => {
    const hasSearchedItem = branch.items.find(item => item.id === action.codeId);

    return hasSearchedItem
      ? { ...branch, items: branch.items.map(item => item.id === action.codeId ? { ...item, deletingCodeItem } : item) }
      : branch;
  });
